import styled from "styled-components";

import OutletCard from "./mocks/outletCard/OutletCard";
import ProductCard from "./mocks/productCard/ProductCard";
import OutletCardSkeleton from "./mocks/outletCard/OutletCardSkeleton";

const Container = styled.div`
  display: flex;
  flex-direction: column;

  > h3 {
    margin-bottom: 10px;
    margin-top: 10px;
    color: black;
  }
`;

type WebCardPreviewsProps = {
  className?: string;
};

export default function WebCardPreviews({ className }: WebCardPreviewsProps) {
  return (
    <Container className={className}>
      <h3>Outlet card</h3>
      <OutletCardSkeleton />
      <OutletCard outletName="Outlet Name" isOutletOpen />
      <OutletCard
        outletName="Outlet Name"
        isOutletOpen={false}
        isOutletSelected
      />

      <h3>Product card</h3>
      <ProductCard productName="Thin Crust Pizza" withoutImage />
      <ProductCard productName="Burger Nitros" />
    </Container>
  );
}
